var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-copyright',_vm._b({style:(_vm.computedTextStyles)},'s-copyright',{ id: _vm.id },false))}
var staticRenderFns = []

export { render, staticRenderFns }